import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';

@Injectable({ providedIn: 'root' })
export class NavigateToolsTool implements IManagementTool {
  private _router = inject(Router);

  readonly name = 'navigate-tools';
  readonly label = 'Tools';
  readonly icon = 'handyman';
  readonly description = 'Navigate to the tools management page';

  async run(_context: IToolRunContext): Promise<void> {
    await this._router.navigate(['/management/tools']);
  }
}
